<template>
  <div>
    <v-container>
      <v-btn @click="back" text class="text_btn">
        <v-icon>keyboard_arrow_left</v-icon>back
      </v-btn>
      <h1>Files settings</h1>
      <br />
      <v-row>
        <v-col>
          <v-form @submit="saveStorageSettings">
            <v-card>
              <v-card-title>Storage</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="storage_in_mb_per_user"
                  label="Storage per user in MB"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn type="submit" text
                  ><i class="fad fa-save" style="margin-right: 5px"></i>
                  Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Files } from "../../logic/Files";
import { Notifications } from "../../notification";

export default {
  name: "FilesSettings",
  data() {
    return {
      project_id: 0,

      storage_in_mb_per_user: 0,
    };
  },
  mounted() {
    this.project_id = this.$route.params.project_id;
    this.load();
  },
  methods: {
    async load() {
      var response = await Files.load(this.project_id);
      if (response.status === 200) {
        this.storage_in_mb_per_user = response.body.storage_in_mb_per_user;
      }
    },
    async saveStorageSettings(e) {
      e.preventDefault();

      var response = await Files.updateStorageQuota(
        this.project_id,
        this.storage_in_mb_per_user
      );
      if (response.status == 200) {
        Notifications.show("The storage quota has been set.");
      } else {
        Notifications.show(response.message);
      }
    },
    back() {
      this.$router.replace("/project/" + this.project_id);
    },
  },
};
</script>

<style>
</style>